import React, { useState, useRef } from "react";
import { getImage } from "../../../../../utils/getImages";

const DealCardsPreview = ({ activetab, cardData }) => {
    const [activeSectionIndex, setActiveSectionIndex] = useState(0);
    const groupRefs = useRef([]); // refs for inline scroll

    if (!cardData) {
        return (
            <div
                style={{
                    textAlign: "center",
                    padding: "40px",
                    border: "1px dashed #ccc",
                    borderRadius: "10px",
                    color: "#777",
                }}
            >
                No preview data available
            </div>
        );
    }

    const getLangText = (item, key) => {
        if (!item) return "";
        switch (activetab) {
            case "simplified_chinese":
                return item[`simplified_chinese_${key}`] || "";
            case "traditional_chinese":
                return item[`traditional_chinese_${key}`] || "";
            case "arabic":
                return item[`arabic_${key}`] || "";
            case "bahasa":
                return item[`bahasa_${key}`] || "";
            default:
                return item[key] || "";
        }
    };

    const activeSection = cardData?.dataArray?.[activeSectionIndex];
    const activeGroups = activeSection?.dataArray || [];

    return (
        <div
            style={{
                padding: "20px",
                background: "#fafafa",
                borderRadius: "10px",
                border: "1px solid #e0e0e0",
            }}
        >
            {/* === Main Title === */}
            <h2
                style={{
                    textAlign: "center",
                    color: "#333",
                    marginBottom: "10px",
                }}
            >
                {getLangText(cardData, "title")}
            </h2>

            <p
                style={{
                    textAlign: "center",
                    color: "#666",
                    marginBottom: "30px",
                    maxWidth: "800px",
                    marginInline: "auto",
                }}
                dangerouslySetInnerHTML={{
                    __html: getLangText(cardData, "description"),
                }}
            />

            {/* === Level 1 Tabs: Sections === */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    borderBottom: "2px solid #eee",
                    marginBottom: "30px",
                }}
            >
                {cardData?.dataArray?.map((section, i) => (
                    <button
                        key={i}
                        onClick={() => setActiveSectionIndex(i)}
                        style={{
                            background: "none",
                            border: "none",
                            outline: "none",
                            cursor: "pointer",
                            padding: "10px 20px",
                            fontSize: "16px",
                            fontWeight: i === activeSectionIndex ? "600" : "400",
                            transition: "all 0.25s ease",
                            borderBottom:
                                i === activeSectionIndex
                                    ? "2px solid #1E2A78"
                                    : "2px solid transparent",
                            color: i === activeSectionIndex ? "#1E2A78" : "#666",
                            fontFamily: "Poppins, sans-serif",
                        }}
                    >
                        {getLangText(section, "title")}
                    </button>
                ))}
            </div>

            {/* === Active Section Content === */}
            {activeSection && (
                <div
                    style={{
                        background: "#fff",
                        padding: "20px",
                        borderRadius: "10px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                    }}
                >
                    {/* === Optional heading_title + description === */}
                    {(activeSection?.heading_title || activeSection?.description) && (
                        <div style={{ textAlign: "center", marginBottom: "25px" }}>
                            {activeSection?.heading_title && (
                                <h3 style={{ color: "#111", marginBottom: "10px" }}>
                                    {getLangText(activeSection, "heading_title")}
                                </h3>
                            )}
                            {activeSection?.description && (
                                <div
                                    style={{
                                        color: "#666",
                                        fontSize: "15px",
                                        maxWidth: "800px",
                                        margin: "0 auto",
                                    }}
                                    dangerouslySetInnerHTML={{
                                        __html: getLangText(activeSection, "description"),
                                    }}
                                />
                            )}
                        </div>
                    )}

                    <h4
                        style={{
                            textAlign: "center",
                            color: "#777",
                            marginBottom: "20px",
                        }}
                    >
                        {getLangText(activeSection, "subtitle")}
                    </h4>

                    {/* === Level 2 Tabs (Scroll Navigation) === */}
                    {activeGroups.length > 0 && (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                flexWrap: "wrap",
                                borderBottom: "2px solid #eee",
                                marginBottom: "30px",
                                gap: "10px",
                            }}
                        >
                            {activeGroups.map((group, gi) => (
                                <button
                                    key={gi}
                                    onClick={() =>
                                        groupRefs.current[gi]?.scrollIntoView({
                                            behavior: "smooth",
                                            block: "start",
                                        })
                                    }
                                    style={{
                                        background: "none",
                                        border: "none",
                                        outline: "none",
                                        cursor: "pointer",
                                        padding: "8px 18px",
                                        fontSize: "15px",
                                        color: "#1E2A78",
                                        fontWeight: 500,
                                        fontFamily: "Poppins, sans-serif",
                                    }}
                                >
                                    {getLangText(group, "title")}
                                </button>
                            ))}
                        </div>
                    )}

                    {/* === Inline Group Sections === */}
                    {activeGroups.map((group, gi) => (
                        <div
                            key={gi}
                            ref={(el) => (groupRefs.current[gi] = el)}
                            style={{ marginBottom: "50px" }}
                        >
                            <h5 style={{ textAlign: "center", color: "#444" }}>
                                {getLangText(group, "title")}
                            </h5>

                            <p
                                style={{
                                    textAlign: "center",
                                    color: "#666",
                                    fontSize: "14px",
                                    maxWidth: "700px",
                                    marginInline: "auto",
                                }}
                                dangerouslySetInnerHTML={{
                                    __html: getLangText(group, "description"),
                                }}
                            />

                            <div
                                style={{
                                    display: "grid",
                                    gridTemplateColumns:
                                        "repeat(auto-fit, minmax(250px, 1fr))",
                                    gap: "20px",
                                    marginTop: "20px",
                                }}
                            >
                                {group?.dataArray?.map((card, ci) => (
                                    <div
                                        key={ci}
                                        style={{
                                            background: "#fff",
                                            border: "1px solid #fcfcfc",
                                            borderRadius: "6px",
                                            overflow: "hidden",
                                            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                                            display: "flex",
                                            flexDirection: "column",
                                        }}
                                    >
                                        {card?.image && (
                                            <img
                                                src={getImage(card.image)}
                                                alt={getLangText(card, "title")}
                                                style={{
                                                    width: "100%",
                                                    height: "220px",
                                                    objectFit: "cover",
                                                }}
                                            />
                                        )}

                                        <div
                                            style={{
                                                backgroundColor: "#0b2b6b",
                                                color: "#fff",
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                padding: "10px 15px",
                                                fontWeight: 600,
                                            }}
                                        >
                                            <div>
                                                <h6
                                                    style={{
                                                        margin: 0,
                                                        fontSize: "15px",
                                                        fontWeight: 600,
                                                        color: "#fff",
                                                    }}
                                                >
                                                    {getLangText(card, "title")}
                                                </h6>
                                                <p style={{
                                                    margin: 0,
                                                    fontSize: "12px",
                                                    fontWeight: 400,
                                                    color: "#fff",
                                                }}>
                                                    {getLangText(card, "sub_title")}
                                                </p>
                                            </div>
                                            <div
                                                style={{
                                                    fontSize: "14px",
                                                    color: "#fff",
                                                    fontWeight: 500,
                                                }}
                                                dangerouslySetInnerHTML={{
                                                    __html: getLangText(card, "card_price"),
                                                }}
                                            />
                                        </div>

                                        <div
                                            style={{
                                                padding: "15px",
                                                fontSize: "14px",
                                                color: "#555",
                                                lineHeight: "1.6",
                                            }}
                                            dangerouslySetInnerHTML={{
                                                __html: getLangText(card, "description"),
                                            }}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}

                    {getLangText(activeSection, "note") && (
                    <p
                        style={{
                        color: "#888",
                        fontSize: "14px",
                        marginTop: "40px",
                        fontStyle: "italic",
                        borderTop: "1px solid #eee",
                        paddingTop: "15px",
                        }}
                        dangerouslySetInnerHTML={{
                        __html: getLangText(activeSection, "note"),
                        }}
                    />
                    )}
                </div>
            )}
        </div>
    );
};

export default DealCardsPreview;
